import { type ReactNode } from 'react';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useSearchStore } from '@pkgs/components/hooks/stores/search/useSearchStore';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { type ObjectTypeCategory } from '../../hooks/stores/search/slices/objectTypeFilterSlice';

import styles from './ObjectTypeFilter.module.css';

type ObjectTypeFilterProps = {
  category: ObjectTypeCategory;
  icon: ReactNode;
};

export const ObjectTypeFilterTab = ({ category, icon }: ObjectTypeFilterProps) => {
  const { t } = useAppContext();
  const objectTypeCategory = useSearchStore((state) => state.objectTypeCategory);
  const setObjectTypeCategory = useSearchStore((state) => state.setObjectTypeCategory);

  return (
    <button
      type="button"
      className={styles.tabButton}
      onClick={() => setObjectTypeCategory(category)}
      aria-selected={objectTypeCategory === category}
      data-testid="search-components__object-type-filter-tab"
    >
      {icon}
      <Copy text={t(`search.searchbar.advFilter.propertyType.${category}`)} />
    </button>
  );
};
